module.exports = __webpack_public_path__ + "media/images/comment-90d0776d4e060940becc36f7c31d9c36.svg";